<template>
  <div>
    <Titles v-if="showGraphics" :datosGrafica="datosGrafica" />
    <div class="container">
      <h2>Comparador de Recursos Financieros</h2>
      <div class="head-comparator container">
        <div style="width: 33%;">
          <b-button class="btn-return" :to="{ name: 'comparate' }">
            <i class="bx bx-left-arrow-alt"></i> Regresar
          </b-button>
        </div>

        <div class="select-year" style="width: 33%;">
          <p class="text-sy">Seleccione un Año:</p>
          <b-form-select
            class="select"
            v-model="selectedYear"
            :options="options"
          ></b-form-select>
        </div>

        <div style="width: 33%;"></div>
      </div>
      <div class="loading" v-show="loading">
        <Loading />
      </div>
      <div v-if="showGraphics">
        <Graphic
          style="padding: 1.5rem;"
          v-for="(item, index) in datosGrafica"
          :key="index"
          :titles="item.titles"
          :data="item.data"
          :title="item.mainTitle"
          :selectedYear="selectedYear"
          :idGraphic="`graphic-` + index"
        />
      </div>
      <AlertError v-if="!loading && !showGraphics" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Graphic from "./Graphic.vue";
import Loading from "../../../components/tools/Loading.vue";
import AlertError from "../../../components/error/AlertError.vue";
import Titles from "./Titles.vue";
export default {
  components: {
    Graphic,
    Loading,
    AlertError,
    Titles,
  },
  data() {
    return {
      options: [{ value: null, text: "- Año -" }],
      selectedYear: "2019",
      titulosGrafica: null,
      datosGrafica: [],
      showGraphics: false,
      loading: true,
    };
  },
  computed: {
    ...mapGetters([
      "rrffComparator",
      "comparatorService_1",
      "comparatorService_2",
    ]),
  },
  methods: {
    getDataComp: async function() {
      try {
        const { comportamiento, resultado } = this.rrffComparator;
        const baseUrl = `${process.env.VUE_APP_RUTA_API}/comparador/?servicio_1=${this.comparatorService_1}&servicio_2=${this.comparatorService_2}&tipo_comparador=financiero`;

        if (
          this.options.length === 1 &&
          this.comparatorService_1 &&
          this.comparatorService_2
        ) {
          const res = await axios.get(baseUrl + "&comportamiento=ppto_final");
          this.setYearList(res.data);
        }

        if (comportamiento) {
          const compFiltro = await axios.get(
            `${baseUrl}&comportamiento=${comportamiento}`
          );
          this.datosGrafica.push(
            this.buildData(
              compFiltro.data,
              "Comportamiento Presupuestario año "
            )
          );
        }
        if (resultado) {
          const resultadoFiltro = await axios.get(
            `${baseUrl}&resultado=${resultado}`
          );
          this.datosGrafica.push(
            this.buildResultData(
              resultadoFiltro.data,
              "Resultados del Presupuesto año "
            )
          );
        }

        this.showGraphics = this.datosGrafica.length > 0;
        this.loading = false;
      } catch (error) {
        this.showGraphics = false;
        this.loading = false;
        console.log(error);
      }
    },
    setYearList: function(list) {
      this.options = Object.keys(list[Object.keys(list)[0]].resultados).map(
        (y) => ({
          value: y,
          text: y,
        })
      );

      this.options.unshift({ value: null, text: "- Año -" });
    },
    buildData: function(data, mainTitle) {
      const labels = Object.keys(data);
      let toAppendData = [[], [], []],
        toAppend,
        i = 1;
      labels.forEach((e) => {
        toAppend = data[e].resultados[this.selectedYear];
        toAppendData[0] = Object.keys(toAppend);

        Object.keys(toAppend).forEach((r) => {
          toAppendData[i].push(toAppend[r]);
        });

        i++;
      });

      return {
        mainTitle: mainTitle,
        titles: labels,
        data: toAppendData,
      };
    },
    buildResultData: function(data, mainTitle) {
      const labels = Object.keys(data);
      let toAppendData = [[], [], []],
        values,
        i = 1;
      labels.forEach((e) => {
        values = data[e].resultados;
        toAppendData[0] = Object.keys(values);

        Object.keys(values).forEach((r) => {
          toAppendData[i].push(values[r]);
        });

        i++;
      });

      return {
        mainTitle: mainTitle,
        titles: labels,
        data: toAppendData,
      };
    },
  },
  watch: {
    selectedYear: function() {
      if (!this.selectedYear) return;
      this.datosGrafica = [];
      this.loading = true;
      this.getDataComp();
    },
  },
  mounted() {
    this.getDataComp();
  },
  destroyed() {
    this.$store.commit("resetRRHHComparator");
  },
};
</script>

<style scoped>
h2 {
  margin-top: 15px;
  text-align: center;
}
.select {
  border: 1px solid rgb(228, 228, 228);
  width: 100px;
  font-size: 16px;
  color: #222222;
  border-radius: 5px;
}
.text-sy {
  margin: 0.5rem;
}
.head-comparator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.select-year {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  /* margin: 0 10%; */
}

.btn-return {
  text-align: center;
  width: 120px;
  color: #696969;
  background: #e0e0e0;
  border: none;
  border-radius: 40px;
  font-size: 16px;
  left: 94px;
}

.btn-return:hover {
  color: #052333;
  background: #24c6ab;
  border: none;
}
.loading {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
